import React from "react";
import "./GeneticPotential.css";

const GeneticPotential = () => {
  return (
    <section className="gp2-section" id="genetic-potential">
      <div className="gp2-container">
        <h2 className="gp2-heading">Take your vision and brain to your genetic potential</h2>
        <p className="gp2-intro">
          Experience evidence-based performance coaching that combines neuroscience with
          practical strategies to help you excel in your endeavors.
        </p>

        <div className="gp2-hero">
          <div className="gp2-media">
            <img src="cricketer_silhoutte.png" alt="Training" className="gp2-image" />
          </div>
          <div className="gp2-copy">
            <h3 className="gp2-subtitle">Elevating Your Performance</h3>
            <p>
              With extensive experience in performance coaching, we empower individuals to surpass
              their limitations and reach their highest potential systematically. Our method combines
              cutting-edge neuroscience and tailored strategies for lasting growth, fostering an
              environment that nurtures intrinsic motivation.
            </p>

            <div className="gp2-stats">
              <div className="gp2-stat"><span className="gp2-num">20+</span><span>Success Stories</span></div>
              <div className="gp2-stat"><span className="gp2-num">10+</span><span>Years of Expertise</span></div>
            </div>

          </div>
        </div>

        <div className="gp2-grid">
          <div className="gp2-card">
            <div className="gp2-icon">⭐</div>
            <h4>Test</h4>
            <p>Comprehensive evaluation of vision and cognitive skills to establish a performance baseline.</p>
          </div>
          <div className="gp2-card">
            <div className="gp2-icon">⚡</div>
            <h4>Train</h4>
            <p>Targeted methods to enhance processing speed, memory, and attention for game‑time decisions.</p>
          </div>
          <div className="gp2-card">
            <div className="gp2-icon">🛠️</div>
            <h4>Transform</h4>
            <p>Follow‑up strategies to ensure gains aren’t just achieved—but sustained over time.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeneticPotential;
